import styled from "styled-components";
const calcWidth = (size) => {
    if (["xm"].includes(size)) {
      return 0;
    }
    if (["xm", "sm", "md"].includes(size)) {
      return 1;
    }
    return 2;
  };
  export const MainStyled = styled.main`
  display:flex;
  `